var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsupportedFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.8223C10.04 13.8223 6.80005 17.0383 6.80005 20.9689C6.80005 24.8996 10.04 28.1156 14 28.1156C17.96 28.1156 21.2 24.8996 21.2 20.9689C21.2 17.0383 17.96 13.8223 14 13.8223ZM14 16.2045C14.9 16.2045 15.74 16.4427 16.46 16.8596L9.86005 23.4107C9.44005 22.696 9.20005 21.8623 9.20005 20.9689C9.20005 18.3485 11.36 16.2045 14 16.2045ZM14 25.7334C13.1 25.7334 12.26 25.4952 11.54 25.0783L18.08 18.5867C18.5 19.3014 18.74 20.1352 18.74 21.0285C18.8 23.5894 16.64 25.7334 14 25.7334Z",
    fill: "#FD3A57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 0.124512H3.80005C2.12005 0.124512 0.800049 1.43473 0.800049 3.10229V30.4978C0.800049 32.1654 2.12005 33.4756 3.80005 33.4756H24.2C25.88 33.4756 27.2 32.1654 27.2 30.4978V12.0356C27.2 5.48451 21.8 0.124512 15.2 0.124512ZM24.2 8.81962C23.66 8.5814 23 8.46229 22.4 8.46229H18.8V4.88896C18.8 4.23385 18.68 3.63829 18.44 3.10229C21.14 4.05518 23.24 6.13962 24.2 8.81962ZM24.8 30.4978C24.8 30.8552 24.56 31.0934 24.2 31.0934H3.80005C3.44005 31.0934 3.20005 30.8552 3.20005 30.4978V3.10229C3.20005 2.74496 3.44005 2.50673 3.80005 2.50673H14C15.32 2.50673 16.4 3.57873 16.4 4.88896V9.6534C16.4 10.3085 16.94 10.8445 17.6 10.8445H22.4C23.72 10.8445 24.8 11.9165 24.8 13.2267V30.4978Z",
    fill: "#FD3A57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsupportedFile);
export default __webpack_public_path__ + "static/media/unsupportedFile.eaa6c3cf.svg";
export { ForwardRef as ReactComponent };